module.exports = __webpack_public_path__ + "images/liinilaevad/favicon-196x196.png";